import { boolean, object, string } from "yup";
import { dayjs } from "@thalamos/common";
/**
 * A yup schema for an External Patient Record pulled from an External System.
 */
export const ExternalPatientDemographicsPullEventSchema = object({
    id: string().uuid().required(),
    externalPatientLinkId: string().uuid().required(),
    created: string()
        .required()
        .transform((value) => dayjs(value).toISOString())
        .required(),
    processed: boolean().required(),
    responseNormalised: object({
        outcome: string().oneOf(["success"]).required(),
        name: object({
            given: string().required().nullable(),
            family: string().required(),
        })
            .required()
            .nullable(),
        address: object({
            address: string().required().nullable(),
            postalCode: string().required().nullable(),
        }).required(),
        dateOfBirth: string().required().nullable(),
        restricted: boolean().required(),
        deceasedDateTime: string().required().nullable(),
        deathNotificationStatus: string()
            .oneOf(["formal", "informal", "removed"])
            .required()
            .nullable(),
        registeredGpOdsCode: string().required().nullable().default(null),
        pdsOfficialDocumentGender: string()
            .oneOf(["male", "female", "other", "unknown"])
            .required()
            .nullable()
            .default(null),
        ethnicity: object({
            code: string().required().nullable(),
            display: string().required().nullable(),
        })
            .required()
            .nullable()
            .default(null),
    }).optional(),
});
// We cannot use yup to infer as it doesn't work for tsoa.
// export type ExternalPatientDemographicsPullEvent = InferType<typeof ExternalPatientDemographicsPullEventSchema>;
// But we can use ObjectSchema<> to ensure they largely stay in sync
//# sourceMappingURL=externalPatientDemographicsPullEvent.js.map